
import { faPencil, faSearch } from '@fortawesome/pro-regular-svg-icons'
import { debounce, throttle } from 'lodash'
import { counties, findCountryFromCounty } from 'pawpaddock-common/data'

export default {
  name: 'InputAddressLookup',

  props: {
    value: {
      type: Object,
      default: () => ({})
    },

    allowManualAddress: {
      type: Boolean,
      default: true
    },

    forceManualAddress: {
      type: Boolean,
      default: false
    },

    allowEditingFullAddress: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: 'Search street or postcode'
    }
  },

  data() {
    return {
      searchAddressApi: new this.$ApiModel(),
      fetchFullAddressApi: new this.$ApiModel(),
      searchQuery: '',
      lastQuery: '',
      isManualAddressInputVisible: false,
      isNewlySelectedAddress: false,
      debouncedSearch: debounce(this.searchAddress, 500, { maxWait: 2000 }),
      throttledSearch: throttle(this.searchAddress, 700),
      counties,
      faPencil,
      faSearch
    }
  },

  computed: {
    compModel: {
      set(newValue) {
        this.$emit('input', newValue)
      },

      get() {
        return this.value
      }
    },

    compResults() {
      return this.searchAddressApi.response?.data || []
    }
  },

  created() {
    if (this.forceManualAddress) {
      this.isManualAddressInputVisible = true
    }
  },

  methods: {
    onSelectAddress(location) {
      this.getFullAddress(location)

      this.$emit('search-results', [])
    },

    onRegionChange(region) {
      console.log({ region })
      this.compModel.addressCountry = findCountryFromCounty(region)

      this.$emit('addressChanged', this.compModel)
    },

    handleInput() {
      // Let's be eager until they've ignored a few suggestions
      if (this.searchQuery.length <= 7 && this.searchQuery.length > 2) {
        this.debouncedSearch()
      } else if (this.searchQuery.length > 7) {
        this.debouncedSearch()
      }
    },

    async getFullAddress(location) {
      this.searchAddressApi.isLoading = true

      try {
        await this.$api.geo(this.fetchFullAddressApi).getFullAddressFromId(location.id)

        this.compModel = {
          ...this.compModel,
          ...this.fetchFullAddressApi.response.data
        }

        this.$emit('addressChanged')

        if (this.$refs.popover) {
          this.$refs.popover.close()
        }

        this.isNewlySelectedAddress = true

        this.searchQuery = this.fetchFullAddressApi.response.data.line_1

        setTimeout(() => {
          this.isNewlySelectedAddress = false
        }, 1300) // Timeout just longer than the search throttle

        this.searchAddressApi.isLoading = false
      } catch (error) {
        this.$notify.error(this.$t('errorChoosingThatAddressTryAgain'))

        this.$log.error('Error selecting address', error)
      }
    },

    async searchAddress() {
      if (!this.searchQuery || this.isNewlySelectedAddress) {
        this.$refs.popover.close()
        return
      }

      const scopedQuery = this.searchQuery

      this.lastQuery = scopedQuery

      await this.$api.geo(this.searchAddressApi).searchAddress(scopedQuery)

      if (this.lastQuery !== this.searchQuery) {
        return
      }

      this.$emit('search-results', this.searchAddressApi.response.data)
      // this.searchAddressApi.isLoading = false
      this.$refs.popover.open()
    },

    async resetAddress() {
      this.$set(this, 'compModel', {})
      this.isManualAddressInputVisible = false

      this.$emit('search-results', [])

      await this.$nextTick()

      setTimeout(() => {
        this.$refs.manualQuery.$el.querySelector('input').focus()
      }, 500)
    }
  }
}
